import { STATUS_KEYS, STATUS_TONES } from "../discover/campaignDisplay";
import { getParticipantTypeLabel } from "../../utils/campaignCardUtils";
import { getPerPlatformRateRows } from "../../utils/campaignRates";
import Badge from "../ds/Badge";
import { PlatformLogo, platformForRateKey } from "./shared";

/**
 * Figma "Campaign hero": the cover under a dark fade, then status, name, what it
 * pays and the actions. Always dark, because its text sits on the photo.
 */
const CampaignHero = ({ campaign, t, actions = null, note = null }) => {
  const rows = getPerPlatformRateRows(campaign);
  const views = (campaign.viewsPerRate || 1000).toLocaleString();
  const end = campaign.endDate ? new Date(campaign.endDate).toLocaleDateString() : t("campaigns.noEndDate");

  return (
    <section
      data-theme="dark"
      className="relative flex min-h-[300px] flex-col justify-end overflow-hidden rounded-radius-lg bg-app-creator-rewards-deep"
    >
      {campaign.campaignLogo && <img src={campaign.campaignLogo} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      <div
        className="absolute inset-0 bg-[linear-gradient(0deg,rgba(10,10,13,0.95),rgba(10,10,13,0.7)_50%,rgba(10,10,13,0.15))]"
        aria-hidden="true"
      />
      <div className="relative flex flex-col gap-space-16 p-space-16 min-[600px]:p-space-24 lg:p-space-32">
        <div className="flex flex-wrap items-center gap-space-8">
          <Badge tone={STATUS_TONES[campaign.status] || "warning"}>{t(STATUS_KEYS[campaign.status] || STATUS_KEYS.pending)}</Badge>
          <Badge>{getParticipantTypeLabel(t, campaign.participantType)}</Badge>
        </div>
        <h1 className="text-title-1 text-label-primary lg:text-large-title">{campaign.campaignName}</h1>
        <div className="flex flex-col gap-space-16 lg:flex-row lg:items-center">
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-space-8">
            {rows.map((row) => (
              <span
                key={row.key || "rate"}
                className="inline-flex h-[26px] items-center gap-space-4 rounded-full bg-material-thin px-space-8 text-caption-1-semibold text-label-primary"
              >
                {row.key && <PlatformLogo platform={platformForRateKey(row.key)} size={14} />}
                {row.rate} ₾
              </span>
            ))}
            <span className="text-footnote text-label-secondary">
              {t("campaignFlow.perViews", { count: views })} · {end}
            </span>
          </div>
          {actions && <div className="flex flex-wrap items-center gap-space-8">{actions}</div>}
        </div>
        {note}
      </div>
    </section>
  );
};

export default CampaignHero;
